import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

function DeleteConfirmationDialog({ open, onClose, onConfirm }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('toyDetail.delete')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('toyDetail.deleteConfirm')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t('toyDetail.deleteConfirmDescription')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t('common.cancel')}
        </Button>
        <Button 
          onClick={onConfirm} 
          color="error" 
          variant="contained"
        >
          {t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationDialog; 